import { MarketingIndustryTypes } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import {
  CompleteSectionFormValues,
  IntroductionFormValues,
  RemarkFormValues,
} from '@Utils/Types/FormValuesTypes';
import useAxios from 'axios-hooks';
import { IInfoCategoryMasterData } from './MasterData';

export interface INatureOfBusiness {
  id: number;
  startOperatingYear: number;
  introduction?: IntroductionFormValues;
  remark?: RemarkFormValues;
  corporateInformation: ICorporateInformation;
  productInformation: IProductInformation;
  marketingIndustry: IMarketingIndustry;
  incomeStructure: IIncomeStructure;
  otherDescriptions?: IOtherExplanations[];
  completedSection?: CompleteSectionFormValues;
}

export interface IOtherExplanations {
  id?: number;
  orderNumber?: number;
  titleTh: string;
  titleEn: string;
  descriptionTh: string;
  descriptionEn: string;
}

export interface ICorporateInformation {
  id?: number;
  companyTh: string;
  companyEn: string;
  symbolTh: string;
  symbolEn: string;
  addressTh: string;
  addressEn: string;
  provinceTh: string;
  provinceEn: string;
  zipcodeTh: string;
  zipcodeEn: string;
  businessTypeTh: string;
  businessTypeEn: string;
  faxTh: string;
  faxEn: string;
  telephoneTh: string;
  telephoneEn: string;
  registeredNumberTh: string;
  registeredNumberEn: string;
  websiteTh: string;
  websiteEn: string;
  emailTh: string;
  emailEn: string;
  remark?: RemarkFormValues;
  completedSection?: CompleteSectionFormValues;
  introduction?: IntroductionFormValues;
}

export enum BusinessTypes {
  MANUFACTURING_SERVICE = 'MANUFACTURING',
  FINANCIAL_INSTITUTIONS = 'FINANCIAL_INSTITUTION',
}

interface IProductInformation {
  id: number;
  businessType: BusinessTypes | null;
  introduction?: IntroductionFormValues;
  remark?: RemarkFormValues;
  businessGroupIntroduction?: IntroductionFormValues;
  businessGroupRemark?: RemarkFormValues;
  completedSection?: CompleteSectionFormValues;
  businessGroupInfos: Array<IBusinessGroupInformation>;
}
interface IBusinessGroupInformation {
  id?: number;
  nameTh: string;
  nameEn: string;
  descriptionTh: string;
  descriptionEn: string;
  sequence: number;
  productInformation: number;
}

interface IMarketingIndustry {
  id: number;
  type: MarketingIndustryTypes | null;
  introduction: IntroductionFormValues;
  remark: RemarkFormValues;
  marketingPolicyIntroduction: IntroductionFormValues;
  marketingPolicyRemark: RemarkFormValues;

  marketingPolicy: IMarketPolicy[];
  completedSection: CompleteSectionFormValues;
}

interface IMarketPolicy {
  id?: number;
  productNameTh?: string;
  descriptionTh: string;
  industryCompetitionDescTh: string;
  productNameEn?: string;
  descriptionEn: string;
  industryCompetitionDescEn: string;
  domesticExportSalesRatio: IDomesticExportSalesRatio[];
  salesRatioIntroduction: IntroductionFormValues;
  salesRatioRemark: IntroductionFormValues;
  remark?: RemarkFormValues;
  introduction?: IntroductionFormValues;
}
interface IDomesticExportSalesRatio {
  id?: number;
  introduction?: IntroductionFormValues;
  sequence: number;
  countryNameTh: string;
  countryNameEn: string;
  countryCodeTh: string;
  countryCodeEn: string;
  ratio: number;
  remark?: RemarkFormValues;
}

export interface IIncomeStructure {
  id?: number;
  introduction?: IntroductionFormValues;
  remark?: RemarkFormValues;
  completedSection: CompleteSectionFormValues;
  incomeItems: Array<IIncomeItem>;
  incomeItemPercents?: Array<IIncomeItem>;
}

export interface IIncomeCategory {
  id?: number;
  nameTh: string;
  nameEn: string;
  subGroup?: string;
  infoCategoryMasterDataId?: number;
  infoCategoryMasterData?: IInfoCategoryMasterData;
  sequence?: number;
}

export interface IIncomeItem {
  id?: number;
  incomeCategory: IIncomeCategory;
  asOfYear?: number;
  asOfYesteryear?: number;
  asOfYearBeforeYesteryear?: number;
}

export const useSaveNatureOfBusiness = (
  req?: INatureOfBusiness,
  reportId?: number
) => {
  return useAxios<INatureOfBusiness>(
    {
      url: `/nature-of-business`,
      params: { reportId },
      data: req,
      method: 'POST',
    },
    { manual: true }
  );
};

export const useGetNatureOfBusiness = (reportId?: number) => {
  return useAxios<INatureOfBusiness>({
    url: `/nature-of-business/${reportId}`,
  });
};

export const useGetNatureOfBusinessOneReport = (
  reportId: string,
  companyScpId: number,
  asOfYear: number
) => {
  return useAxios(
    {
      url: `/nature-of-business/${reportId}/one-report`,
      method: 'POST',
      data: { companyScpId, asOfYear },
    },
    { manual: true }
  );
};
